import { useTranslation } from "react-i18next";
import { getNamespaceFromPath } from "../i18n";

export const useTran = (ns = getNamespaceFromPath(), options = {}) => {
  const tran = useTranslation(ns, options);
  return tran;
};
